import React from 'react';
import {colors} from '../theme/tokens/colors';

export interface CreditCardIconProps {
  color?: keyof typeof colors;
  size?: number;
  style?: React.CSSProperties;
}

export const CreditCardIcon = React.memo<CreditCardIconProps>(
  ({color = 'textLow', size = 24, style}) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4C3.34315 4 2 5.34315 2 7V9V10V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V10V9V7C22 5.34315 20.6569 4 19 4H5ZM4 7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V8H4V7ZM4 11V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V11H4ZM13 15C13 14.4477 13.4477 14 14 14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H14C13.4477 16 13 15.5523 13 15Z"
        fill={colors[color] || color}
      />
    </svg>
  ),
);
